import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import {
    VerificationService,
    SuccessResponse,
    FormFooterComponent,
} from '@sheerid/jslib';
import { LogoComponent } from '../LogoComponent/LogoComponent'
import { getMetadataByKey, getQueryParamsByName } from '../../metadataQueryString';
import { isRenderedInIframe } from '../IsRenderedInIframe';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {

    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}';
    const renderedInIframe = isRenderedInIframe();
    const qs = getMetadataByKey(verificationService, 'qs') || getQueryParamsByName('qs');
    let redirectUrl = "";

    if (qs) {
        redirectUrl = `https://www.llbean.com/?qs=${qs}&pcd=${rewardCode}`;
    }
    else {
        redirectUrl = `https://www.llbean.com/?pcd=${rewardCode}`;
    }

    return (
        <div id="sid-step-success" className={`${!renderedInIframe ? 'sid-l-container' : ''}`}>
            <div className="sid-header sid-l-horz-center">
                <div className={`sid-logo sid-l-horz-center ${renderedInIframe ? 'sid-lightbox__logo' : ''}`}>
                    <LogoComponent verificationService={verificationService} />
                </div>
                <div className={`sid-header__title ${renderedInIframe ? 'sid-lightbox__title' : ''}`}>
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success" />
                </div>
            </div>
            <div className={`sid-l-container ${renderedInIframe ? 'sid-lightbox' : ''}`}>
                <div className="sid-header sid-l-horz-center">
                    <div className="sid-header__title-two">
                        <FormattedHTMLMessage id="step.success.titleTwo" defaultMessage="You've been verified." />
                    </div>
                    <div className="sid-header__subtitle">
                        <FormattedHTMLMessage id="step.success.subtitle" defaultMessage="Below is your single-use coupon code - click now to activate it right away. Your single-use coupon code can be used during checkout at L.L.Bean."/>
                    </div>
                </div>

                <div className="sid-reward-code sid-l-space-top-md sid-h-jumbo-text">
                    {rewardCode}
                </div>

                <div className="sid-submit sid-l-space-top-md">
                    <a href={redirectUrl} target="_parent" className="sid-btn sid-btn-light">
                        <FormattedHTMLMessage id="step.success.redirectButtonText" defaultMessage="ACTIVATE NOW" />
                    </a>
                </div>

                <div className="sid-footer sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.emailNotification" defaultMessage="To make sure you have every opportunity to use your discount, we're also emailing you a copy of your code - along with a barcode to use if redeeming at our L.L.Bean Retail Stores - so you can either shop now or at a later date. Please check for an email from us (verify@sheerid.com) for all the details."/>
                </div>

                <FormFooterComponent verificationService={verificationService}></FormFooterComponent>
            </div>
        </div>
    );
};

export { StepSuccessComponent };
